import instance from '../axios';

export const getPriceChangeDates = () => {
    return instance.get('/priceHistory/dates');
}